import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getGoodsOperational = createAsyncThunk(
  "admin/goods-operational",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/goods-operational", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getGoodsOperationalById = createAsyncThunk(
  "admin/goods-operational/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/goods-operational/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortGoodsOperational = createAsyncThunk(
  "admin/goods-operational/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/goods-operational/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postGoodsOperational = createAsyncThunk(
  "admin/goods-operational/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/goods-operational", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteGoodsOperational = createAsyncThunk(
  "admin/goods-operational/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/goods-operational/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateGoodsOperational = createAsyncThunk(
  "admin/goods-operational/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/goods-operational/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const goodsOperationalSlice = createSlice({
  name: "Customer Region Store",
  initialState: initialState,
  reducers: {
    addGoodsOperational(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortGoodsOperational(state, action) {
      state.data.docs = action.payload;
    },
    deleteGoodsOperational(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editGoodsOperational(state, action) {
        let index = state.data.docs.findIndex(item => item._id === action.payload._id);
        state.data.docs[index] = action.payload;
    },
  },
  extraReducers: {
    [getGoodsOperational.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getGoodsOperational.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getGoodsOperational.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getGoodsOperationalById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getGoodsOperationalById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getGoodsOperationalById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortGoodsOperational.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortGoodsOperational.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortGoodsOperational.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postGoodsOperational.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postGoodsOperational.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postGoodsOperational.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteGoodsOperational.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteGoodsOperational.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteGoodsOperational.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateGoodsOperational.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateGoodsOperational.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateGoodsOperational.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const goodsOperationalActions = goodsOperationalSlice.actions;

export default goodsOperationalSlice.reducer;
